export class EditableFieldNode {
	public id: string;
	public label: string;
	public type: EditableFieldType;
	public parentId: string;
	public caseId?: string;
	public accountId?: string;
	public isEditing = false;
	public rank?: number;
	public readonly nodeType = "node" as const;

	constructor(params?: EditableFieldNodeParams) {
		this.id = params?.id;
		this.label = params?.label;
		this.type = params?.type;
	}
}

interface EditableFieldNodeParams {
	id: string;
	label: string;
	type: EditableFieldType;
	flatIndex?: number;
}

export type EditableFieldType = 'section' |'checkbox' | 'input' | 'shared-checkbox';
